<template>
  <Block :title="$t('other')" class="info-block">
    <md-field>
      <md-field-item :title="$t('present_address')" :addon="other.residentialAddress" />
      <md-field-item :title="$t('present_address_zip_code')" :addon="other.residentialPostalCode" />
      <md-field-item :title="$t('permanent_address')" :addon="other.address" />
      <md-field-item :title="$t('2025090522509_6b109d10')" :addon="other.postalCode" />
      <md-field-item :title="$t('email_address')" :addon="other.email" />
    </md-field>
  </Block>
</template>

<script>
import Block from '@/components/Block'
import { Field, FieldItem } from 'mand-mobile'

// 其他信息组件
export default {
  name: 'Other',
  components: {
    Block,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem
  },
  props: {
    other: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang='scss'>
.info-block {
  .flash-block__content {
    .flash-block_body {
      padding: 0;
    }
  }
}
</style>
